// extracted by mini-css-extract-plugin
export default {"circle":"DragAndDrop_circle__7ypoy"};